export const CtrlCMode = 0; //Копировать
export const CtrlXMode = 1; //Переместить
export const FETCH_STATE = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const STORAGE_TYPE = {
  table: 'table',
  puck: 'puck',
};
